"use strict";

module.exports = require('./tooltipOnEllipsis/tooltipOnEllipsis');